import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { DIALOG_CONFIG } from 'src/app/shared/global-config';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { S3_URL_BASE } from 'src/environments/environment';
import { DeviceTypeSelectDialogComponent } from '../../dynamic-form/components/form-image/device-type-select-dialog/device-type-select-dialog.component';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.sass'],
})
export class ImageComponent implements OnInit {
  image: any;
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  typeCes?: TypeCesEnum | undefined;
  @ViewChild('uploadFile') uploadFile: ElementRef<HTMLElement>;

  constructor(
    public dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) {}

  ngOnInit(): void {}

  openDialog() {
    this.dialog
      .open(DeviceTypeSelectDialogComponent, {
        ...DIALOG_CONFIG,
        width: '600px',
      })
      .afterClosed()
      .subscribe((data: any) => {
        if (data.image) {
          this.image = data.image;
          this.group.get(this.config.name)?.patchValue(data.image);
        }
      });
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  // APENAS PARA MOBILE
  async upload(event: any) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;

    if (fileList) {
      if (fileList[0]) {
        this.image = await new GlobalUtils().getBase64Url(fileList);
        this.group.get(this.config.name)?.patchValue(this.image);
      } else {
        this.image = fileList[0];
      }
    }
  }

  getImgUri() {
    if (
      this.group.get(this.config.name)?.getRawValue().indexOf('base64') == -1
    ) {
      return `${S3_URL_BASE}${this.group.get(this.config.name)?.getRawValue()}`;
    } else {
      return this.group.get(this.config.name)?.getRawValue();
    }
  }

  public selectImage() {
    const isMobile = this.deviceService.isMobile();
    if (isMobile) this.uploadFile.nativeElement.click();
    if (!isMobile) this.openDialog();
  }
}
